import { combineReducers } from 'redux';
import { messagesWarning } from './messagesWarning';

const reducers = combineReducers({ messagesWarning });

export { reducers };
